import { useContext } from 'react';
import { createContext } from 'react';

import { StackLayoutProps } from '../@types/StackLayoutProps';

export const StackLayoutContext = createContext<StackLayoutProps>({} as StackLayoutProps);

StackLayoutContext.displayName = 'StackLayout';

const StackLayoutProvider = (props: StackLayoutProps) => (
	<StackLayoutContext.Provider value={props}>{props.children}</StackLayoutContext.Provider>
);

export const useStackLayout = () => {
	const context = useContext(StackLayoutContext);

	return context;
};

export default StackLayoutProvider;
